import { render, staticRenderFns } from "./WabaAnalys.vue?vue&type=template&id=fdd2a21a&scoped=true"
import script from "./WabaAnalys.vue?vue&type=script&lang=js"
export * from "./WabaAnalys.vue?vue&type=script&lang=js"
import style0 from "./WabaAnalys.vue?vue&type=style&index=0&id=fdd2a21a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdd2a21a",
  null
  
)

export default component.exports